(() => {
  'use strict';
  function setup(root = document) {
    root.querySelectorAll('[data-native-auto-filters]:not([data-auto-ready])').forEach(form => {
      form.addEventListener('change', event => {
        if (event.target.matches('select, input[type=checkbox]')) form.requestSubmit();
      });
      form.dataset.autoReady = 'true';
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('.filter-detail[open]').forEach(detail => {
      if (!detail.contains(event.target)) detail.open = false;
    });
    if (event.target.closest('.menu-toggle') && document.body.classList.contains('menu-open')) {
      document.querySelector('.mobile-menu a')?.focus();
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || !document.body.classList.contains('menu-open')) return;
    const controls = [document.querySelector('.menu-toggle'), ...document.querySelectorAll('.mobile-menu a')].filter(Boolean);
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();
